var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387.1,248.8c31.5,2.1,59.7-19.4,65.9-50.3c-7.6-11.8-20.6-18.8-34.6-18.8C382,178.8,362.4,222.1,387.1,248.8L387.1,248.8z  M240.1,75.1l85.8-49.7L298.6,10L180.3,78.6l9.4,5.3l17.9,10.1L240.1,75.1L240.1,75.1z M336.9,20.9l3,3l39.8,121.6 c0.8,2.1-0.1,4.4-2,5.5c-31.5,18.5-46.7,55.9-37.1,91.1c10.5,38.3,47,63.3,86.5,59.3c2.2-0.2,4.2,1.2,4.9,3.3l41,124.9 c0.7,2.1-0.2,4.3-2,5.5l-125.8,76.4l-2.1,0.6l-3.2-0.7l-44.3-28.8l-1.7-2.1l-86.4-206.5l-131.6,78l-0.8,0.5l-4.2-0.3l-29.8-17.5 c-2.2-1.2-3-3.9-1.8-6.1L166.6,76.5l2.2-2.1L296.2,0.7c1.4-0.8,3.2-0.9,4.7-0.1L336.9,20.9z M203.7,102.5l-30.9-17.4L49.6,328.9 L72,342.1l106.2-144.3c1-1.4,2.7-2.2,4.3-1.9c1.7,0.2,3.1,1.2,3.8,2.8l115.7,276.9l30.9,20L203.7,102.5L203.7,102.5z M418.3,271.5 c-36.1,0-60.6-36.7-46.8-70.1c13.8-33.3,57-41.9,82.5-16.4c9.5,9.5,14.9,22.3,14.9,35.8C469,248.8,446.3,271.5,418.3,271.5 L418.3,271.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoPlain);
export default __webpack_public_path__ + "static/media/expo-plain.09a069504ab1fbbc396a9885a6989bd2.svg";
export { ForwardRef as ReactComponent };